import React from "react";
import { useHistory } from "react-router-dom";

import "../App.css";

const Checkout_fail = () => {
  const history = useHistory();
  return (
    <div className="checkout_ok">
      <img src="./img/error.gif" alt=""></img>
      <h1>Ha ocurrido un error.</h1>
      <p>¡Pero no te preocupes! Siempre puedes intentarlo denuevo.</p>
      <p
        rel="noopener noreferrer"
        target="_blank"
        onClick={() => history.push("/")}
        style={{
          textDecoration: "underline",
          opacity: "0.9",
          cursor: "pointer",
        }}
      >
        Presiona aquí para volver.
      </p>
    </div>
  );
};

export default Checkout_fail;
